import React, { useEffect, useState } from 'react';
import { ProyeccionHistoricoHEDTO } from './TypesProyeccionDirectivo';
import Cargando from 'components/Varios/Cargando';
import { Row, Col, Table, Button } from "reactstrap";
import CardRegimenHEInicio from './CardRegimenHEInicio';
import { ObtenerDetalleHistoricoProyeccion } from './FunctionsProyeccionDirectivoUnidad';
import { showAlert } from 'components/Admin/Horas Extras/Parametros Horas Extras/Actividades/ActividadesHorasExtras';


export default function ProyeccionHEInicio() {

    const [loading, setloading] = useState<boolean>(false)
    const [historialProyeccion, sethistorialProyeccion] = useState<ProyeccionHistoricoHEDTO[]>([]);

    async function ObtenerInformacionGeneral() {
        setloading(true)
        const informacionGeneral = await ObtenerDetalleHistoricoProyeccion();
        
        if (informacionGeneral.status === 200 && informacionGeneral.dataResponse) {

            if (typeof (informacionGeneral.dataResponse) === "string") {
                showAlert(informacionGeneral.dataResponse, false);
            }
            else {
                sethistorialProyeccion(informacionGeneral.dataResponse)

            }
        }

        else if (informacionGeneral.status === 401) {
            showAlert("No se encuentra autorizado a realizar esta acción", false);
        }

        else {
            const mensajeDefault = "Ha ocurrido un inconveniente";
            showAlert(informacionGeneral.errorMessage ?? mensajeDefault, false) // Set an empty state
        }
        setloading(false)
    }

    const contenidoCardRegimen = (
        <Row>
            <Col xl={12}>
                <Row>
                    {historialProyeccion.map((regimen, index) => (
                        <Col xl={4} key={index} className="mb-3 same-height-container">
                            <CardRegimenHEInicio
                                anio={regimen.anio}
                                historiaProyeccion={regimen}
                                puedeRealizarAccion={regimen.puedeIngresar}
                                periodoVigente={regimen.periodoVigente}
                                index={index}
                            />
                        </Col>
                    ))}
                </Row>
            </Col>
        </Row>
    );


    useEffect(() => {
        ObtenerInformacionGeneral()
    }, [])


    const TITULO_PANTALLA = `PROYECCIÓN ANUAL DE HORAS EXTRAS`;

    return (
        <>
            {loading && <Cargando />}
            {!loading && (
                <div className="content">
                    <div className="titulo_seccion mb-5"> {TITULO_PANTALLA}</div>
                    {contenidoCardRegimen}
                </div>
            )}
        </>
    )
}
